<app-payments-analytics></app-payments-analytics>

<div class="adaptive-row">
  <div class="row">
    <app-payment-page-analytics></app-payment-page-analytics>
    <app-support-analytics> </app-support-analytics>
  </div>
  <app-requests-analytics> </app-requests-analytics>
</div>

<app-returns-analytics></app-returns-analytics>
